import React from 'react';
import styled from 'styled-components';

import { IconChevronLeft, IconChevronRight } from '@prisjakt/ui/icon';

import {
  ArrowStyles,
  StyledBreadcrumbs,
  Crumb,
  Current,
  Ellipsis,
} from './styles';

export type BreadcrumbPath = {
  id: string | number;
  name: string;
  pathName: string;
};

type BreadcrumbProps = {
  className?: string;
  homeText: string;
  path: BreadcrumbPath[];
  firstPathSelectable?: boolean;
  onClick?: (nextPage: string) => void;
};

const ArrowLeft = styled(IconChevronLeft)`
  ${ArrowStyles}
`;

const ArrowRight = styled(IconChevronRight)`
  ${ArrowStyles}
`;

export const Breadcrumbs = (props: BreadcrumbProps) => {
  const {
    firstPathSelectable = false,
    path = [],
    className = undefined,
    homeText,
    onClick,
  } = props;

  const renderMobile = () => {
    const length = path.length;

    const item =
      path.length <= 1
        ? { name: homeText, pathName: '/' }
        : path[firstPathSelectable ? length - 1 : length - 2];

    return (
      <StyledBreadcrumbs $mobile data-test="Breadcrumbs" className={className}>
        <Crumb
          to={item.pathName}
          data-test-path={item.pathName}
          onClick={() => onClick?.(item.pathName)}
        >
          <ArrowLeft size={19} />
          <Ellipsis>{item.name}</Ellipsis>
        </Crumb>
      </StyledBreadcrumbs>
    );
  };

  const renderDesktop = () => {
    return (
      <StyledBreadcrumbs $desktop data-test="Breadcrumbs" className={className}>
        <Crumb to="/">{homeText}</Crumb>

        {path.map((p, index) => (
          <React.Fragment key={p.name}>
            <ArrowRight size={19} />

            {(index !== path.length - 1 || firstPathSelectable) && (
              <Crumb
                to={p.pathName}
                data-test-path={p.pathName}
                onClick={() => onClick?.(p.pathName)}
              >
                <Ellipsis title={p.name}>{p.name}</Ellipsis>
              </Crumb>
            )}

            {index === path.length - 1 && !firstPathSelectable && (
              <Current data-test-path={p.pathName}>
                <Ellipsis title={p.name}>{p.name}</Ellipsis>
              </Current>
            )}
          </React.Fragment>
        ))}
      </StyledBreadcrumbs>
    );
  };

  return (
    <>
      {renderMobile()}
      {renderDesktop()}
    </>
  );
};
